<template>
  <ion-page>
    <Background></Background>
    <WhiteBackground></WhiteBackground>
    <FabColumn>
      <AboutButton back_url="Login"></AboutButton>
    </FabColumn>

    <ion-content class="auth-content login-content">
      <MainTitle class="auth-title" text="中大網上認知測試"></MainTitle>
      <MainSubtitle class="auth-subtitle" text="請在安靜的環境下進行"></MainSubtitle>
      <InputBox class="auth-input" text="賬號" placeholder="請輸入手提電話號碼或機構名稱" textWidth="short" margin_top="short" @getValue="getAccountValue" ref="account"></InputBox>
      <InputBox class="auth-input" text="密碼" placeholder="請輸入密碼" textWidth="short" margin_top="short" type="password" @getValue="getPasswordValue" ref="password"></InputBox>
      <LoginBottomTips class="auth-tip auth-forgot" text="忘記密碼？" position="right" @click="goForgetPassword"></LoginBottomTips>
      <ConfirmButton class="auth-button" text="登入" position="relative" @click="doLogin"></ConfirmButton>
      <LoginBottomTips class="auth-tip" text="註冊新帳戶" @click="goRegister" show_brain="1"></LoginBottomTips>
      <TermsModal :consent="consent" :confirmation="confirmation"></TermsModal>
    </ion-content>
  </ion-page>
</template>

<script>
import Background from "../components/common/Background";
import { IonContent, IonPage } from "@ionic/vue";
import WhiteBackground from "../components/common/WhiteBackground";
import LoginBottomTips from "../components/login/LoginBottomTips";
import TermsModal from "../components/login/TermsModal";
import MainTitle from "../components/common/MainTitle";
import AboutButton from "../components/common/AboutButton";
import ConfirmButton from "../components/common/ConfirmButton";
import router from "../router";
import common from "../common";
import MainSubtitle from "../components/common/MainSubtitle";
import InputBox from "../components/common/InputBox";
export default {
  name: "Login",
  components: {
    InputBox,
    MainSubtitle,
    ConfirmButton,
    AboutButton,
    MainTitle,
    LoginBottomTips,
    WhiteBackground,
    TermsModal,
    Background,
    IonPage,
    IonContent,
  },
  data() {
    return {
      account: '',
      password: '',

      consent: '',
      confirmation: '',
    }
  },

  ionViewWillEnter() {
    this.getUserAgreement();
  },

  ionViewDidLeave() {
    Object.assign(this.$data, this.$options.data());
    this.$refs.account.clearData()
    this.$refs.password.clearData()
  },
  methods: {
    getUserAgreement: function () {
      common.apiGetData('/getUserAgreement').then(res => {
        if (res === false) {
          return false;
        }
        this.consent = res.consent.content,
        this.confirmation = res.confirmation.content
      })
    },
    goRegister: function (e) {
      if (e.target.localName !== 'span') {
        return;
      }
      router.replace('/register')
    },
    getAccountValue: function (value) {
      this.account = value;
    },
    getPasswordValue: function (value) {
      this.password = value;
    },
    doLogin: function () {
      if (this.account.trim().length === 0 || this.password.trim().length === 0) {
        common.showAlert('請輸入您的帳戶和密碼。');
        return false;
      }

      const loading = common.showLoading();
      common.apiPostData('/login', { account: this.account, password: this.password }, false, loading).then(res => {
        if (res === false) {
          return false;
        }


        common.setStorage(common.config.token_key, res.api_token);
        common.setStorage('users', res.users);
        common.setStorage('staff', res.staff);
        common.setStorage('account_mobile', res.mobile);
        router.replace('/home')

      })
    },
    goForgetPassword: function (e) {
      if (e.target.localName !== 'span') {
        return;
      }
      router.replace('/forgetPasswordByMobile')
    }
  }
}
</script>

<style scoped>

.auth-input {
  text-align: center;
  transform: translateX(clamp(-2rem, -4vw, -1rem));
}

@media (max-width: 640px) {
  .auth-input {
    transform: none;
  }
}
</style>
